module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Present')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.present),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "present", $$v)
      },
      expression: "getSettingsVideo.present"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/video/No device'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/video/Video camera'),
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Manual')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.manualrec),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "manualrec", $$v)
      },
      expression: "getSettingsVideo.manualrec"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Triggering')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.audiotrig),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "audiotrig", $$v)
      },
      expression: "getSettingsVideo.audiotrig"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Moving detection')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsVideo.movdetect),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "movdetect", $$v)
      },
      expression: "getSettingsVideo.movdetect"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/video/Settings')
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Pre')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.pretime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "pretime", $$v)
      },
      expression: "getSettingsVideo.pretime"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "no pre-record"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "5s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "10s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "15s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "20s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "25s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "30s"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/video/Post')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsVideo.posttime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsVideo, "posttime", $$v)
      },
      expression: "getSettingsVideo.posttime"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "no post-record"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "10s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "30s"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "1min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "4",
      "label": "2min "
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "5",
      "label": "5min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "6",
      "label": "10min"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Format SD",
      "visible": _vm.formatSDdialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.formatSDdialog = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/device/formatSDdialog')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = false, _vm.formatSD()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogContinue')) + " ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.formatSDLoading,
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.formatSDdialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/device/Format')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.setDeviceLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.setDevice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/video/SetDevice')))])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1b23e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Video.vue
// module id = 464
// module chunks = 1